document.addEventListener('DOMContentLoaded', () => {

  const formatMoney = (cents) => `Rs. ${(cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  let isUpdating = false; 

  // =========================================================
  // 1. OPEN / CLOSE DRAWER 
  // =========================================================
  document.addEventListener('click', (e) => {
    if (e.target.closest('form[action*="/cart/add"], button[name="add"], .add-to-cart, [data-add-to-cart]')) return; 

    let isCartClick = false;
    let target = e.target;
    
    while (target && target !== document.body) {
      if (
        (target.tagName === 'A' && target.getAttribute('href') && target.getAttribute('href').includes('/cart')) ||
        (target.classList && Array.from(target.classList).some(c => c.toLowerCase().includes('cart') && !c.includes('custom-cart-drawer') && !c.includes('add'))) ||
        target.getAttribute('data-cart-icon') !== null ||
        target.getAttribute('id') === 'cart-icon' ||
        target.tagName === 'svg' && target.classList.contains('icon-cart')
      ) {
        isCartClick = true;
        break;
      }
      target = target.parentNode;
    }

    if (isCartClick && !e.target.closest('.custom-cart-drawer')) {
      e.preventDefault();
      e.stopPropagation(); 
      openCartDrawer();
    }
    
    if (e.target.closest('#CloseCartDrawer') || e.target.closest('#CartDrawerOverlay') || e.target.closest('#ContinueShoppingBtn')) {
      if(e.target.closest('#ContinueShoppingBtn')) e.preventDefault();
      closeCartDrawer();
    }
  }, true);

  function openCartDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      refreshCartDrawerUI().then(() => triggerRewardsCheck());
    }
  }

  function closeCartDrawer() {
    const drawer = document.getElementById('CartDrawer');
    if (drawer) {
      drawer.classList.remove('is-open');
      document.body.style.overflow = 'auto';
    }
  }

  // =========================================================
  // 2. DEBOUNCE TIMER
  // =========================================================
  let evalTimer = null;
  function triggerRewardsCheck() {
    clearTimeout(evalTimer);
    evalTimer = setTimeout(() => {
      evaluateRewards();
    }, 250); 
  }

  // =========================================================
  // 3. NETWORK INTERCEPTORS
  // =========================================================
  const originalFetch = window.fetch;
  window.fetch = async function() {
    const response = await originalFetch.apply(this, arguments);
    const url = arguments[0];
    if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'))) {
      if (!url.includes('source=drawer')) { 
        setTimeout(() => { 
          refreshCartDrawerUI().then(() => { 
            if(url.includes('/cart/add')) openCartDrawer(); 
            triggerRewardsCheck(); 
          }); 
        }, 300); 
      }
    }
    return response;
  };

  const originalXHR = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function() {
    this.addEventListener('load', function() {
      if (this.responseURL && (this.responseURL.includes('/cart/add') || this.responseURL.includes('/cart/change') || this.responseURL.includes('/cart/update') || this.responseURL.includes('/cart/clear'))) {
        if (!this.responseURL.includes('source=drawer')) { 
          setTimeout(() => { 
            refreshCartDrawerUI().then(() => { 
              if(this.responseURL.includes('/cart/add')) openCartDrawer(); 
              triggerRewardsCheck(); 
            }); 
          }, 300);
        }
      }
    });
    return originalXHR.apply(this, arguments);
  };

  // =========================================================
  // 4. INTERNAL CART CONTROLS 
  // =========================================================
  document.addEventListener('click', async (e) => {
    const minusBtn = e.target.closest('[data-custom-minus]');
    const plusBtn = e.target.closest('[data-custom-plus]');
    const removeBtn = e.target.closest('[data-custom-remove]');

    if (minusBtn) { e.preventDefault(); await updateCartItem(minusBtn.dataset.key, parseInt(minusBtn.dataset.qty, 10) - 1); }
    if (plusBtn) { e.preventDefault(); await updateCartItem(plusBtn.dataset.key, parseInt(plusBtn.dataset.qty, 10) + 1); }
    if (removeBtn) { e.preventDefault(); await updateCartItem(removeBtn.dataset.key, 0); }
    
    // DISCOUNT CODE PASS-THROUGH
    if (e.target.id === 'ApplyDiscountBtn') {
      e.preventDefault();
      const activeDiscount = sessionStorage.getItem('custom_cart_discount');
      
      if (activeDiscount) {
        sessionStorage.removeItem('custom_cart_discount');
        triggerRewardsCheck();
      } else {
        const inputEl = document.getElementById('CartDiscountCode');
        const code = inputEl ? inputEl.value.trim().toUpperCase() : '';
        if (code !== '') {
          sessionStorage.setItem('custom_cart_discount', code);
          triggerRewardsCheck();
        }
      }
    }
  });

  async function refreshCartDrawerUI() {
    try {
      const response = await originalFetch(window.Shopify.routes.root + '?section_id=cart-drawer&t=' + Date.now());
      const html = await response.text();
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, 'text/html');
      const newBody = newDoc.getElementById('CartDrawerBody');
      const currentBody = document.getElementById('CartDrawerBody');
      if (newBody && currentBody) { currentBody.innerHTML = newBody.innerHTML; }
    } catch (err) { console.error("UI Refresh Error", err); }
  }

  async function updateCartItem(key, quantity) {
    if (isUpdating) return;
    isUpdating = true;
    try {
      await originalFetch(window.Shopify.routes.root + 'cart/change.js?source=drawer', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: quantity })
      });
      await refreshCartDrawerUI();
    } catch (error) {} 
    finally { 
      isUpdating = false; 
      triggerRewardsCheck(); 
    }
  }

  // =========================================================
  // 5. NATIVE SHOPIFY SYNC + EXCLUSION OVERRIDE
  // =========================================================
  async function evaluateRewards() {
    if (isUpdating) return; 
    
    const container = document.getElementById('CartDrawer');
    if (!container) return;

    const excludedIds = (container.dataset.excludedProducts || '').split(',').filter(Boolean);
    const shipThresh = parseInt(container.dataset.ship) || 99900;
    const maxThresh = parseInt(container.dataset.max) || 329900;
    const activeDiscount = sessionStorage.getItem('custom_cart_discount') || '';

    const tiers = [
      { id: container.dataset.t1Id, idB: null, thresh: parseInt(container.dataset.t1Thresh) },
      { id: container.dataset.t2Id, idB: null, thresh: parseInt(container.dataset.t2Thresh) },
      { id: container.dataset.t3Id, idB: container.dataset.t3IdB, thresh: parseInt(container.dataset.t3Thresh) }
    ];

    try {
      const response = await originalFetch(window.Shopify.routes.root + 'cart.js?t=' + Date.now());
      let cart = await response.json();

      let validSubtotalForGifts = 0;
      let originalSubtotal = 0;
      let displaySubtotal = 0;

      cart.items.forEach(item => {
        const isGift = item.properties?._free_gift || item.price === 0;
        if (!isGift) {
          const pid = item.product_id.toString();
          originalSubtotal += item.original_line_price;
          
          let lineFinalPrice = item.final_line_price;
          let showStrikethrough = false;

          // FORCE OVERRIDE IF PRODUCT IS EXCLUDED
          if (excludedIds.includes(pid)) {
            lineFinalPrice = item.original_line_price;
          } else {
            if (item.original_line_price > lineFinalPrice) {
              showStrikethrough = true;
            }
          }

          displaySubtotal += lineFinalPrice;
          validSubtotalForGifts += lineFinalPrice;
          
          const removeBtn = document.querySelector(`[data-custom-remove][data-key="${item.key}"]`);
          if (removeBtn) {
            const priceContainer = removeBtn.closest('.custom-cart-drawer__item-details').querySelector('.custom-cart-drawer__price');
            if (priceContainer) {
              if (showStrikethrough) {
                priceContainer.innerHTML = `<s style="color: #999; font-size: 11px; display: block; line-height: 1.2;">${formatMoney(item.original_line_price)}</s> <span style="font-weight: 600;">${formatMoney(lineFinalPrice)}</span>`;
              } else {
                priceContainer.innerHTML = `<span style="font-weight: 600;">${formatMoney(item.original_line_price)}</span>`;
              }
            }
          }
        }
      });

      let totalDiscountCents = originalSubtotal - displaySubtotal;

      // Update Subtotals & Discounts UI natively
      const originalSubtotalEl = document.getElementById('CartDrawer-OriginalSubtotal');
      if (originalSubtotalEl) {
        originalSubtotalEl.innerHTML = `<span style="font-weight:500;">${formatMoney(originalSubtotal)}</span>`; 
      }

      const discountRow = document.getElementById('CartDrawer-DiscountRow');
      const discountVal = document.getElementById('CartDrawer-TotalDiscount');
      const promoBanner = document.querySelector('.custom-cart-drawer__promo-banner');
      
      if (totalDiscountCents > 0) {
        if (discountRow) discountRow.style.display = 'flex';
        if (discountVal) discountVal.innerHTML = `-${formatMoney(totalDiscountCents)}`;
        if (promoBanner) promoBanner.innerHTML = `<p style="margin: 0; font-size: 13px; color: #27ae60;">🎉 <strong>Awesome!</strong> Your automatic discounts have been applied!</p>`;
      } else {
        if (discountRow) discountRow.style.display = 'none';
        if (promoBanner) promoBanner.innerHTML = `<p style="margin: 0; font-size: 13px; color: #2c3e50;">✨ <strong>Special Offer:</strong> Discounts will automatically apply to eligible items!</p>`;
      }

      let shippingCost = (displaySubtotal < shipThresh && displaySubtotal > 0) ? 15000 : 0;
      const shippingEl = document.getElementById('CartDrawer-Shipping');
      const totalEl = document.getElementById('CartDrawer-Total');

      if (shippingEl) {
        if (shippingCost > 0) {
          shippingEl.innerHTML = formatMoney(shippingCost);
          shippingEl.style.color = '#333';
        } else {
          shippingEl.innerHTML = 'FREE';
          shippingEl.style.color = '#1d8a74';
        }
      }

      if (totalEl) totalEl.innerHTML = formatMoney(displaySubtotal + shippingCost);

      // --- DISCOUNT INPUT UI CONTROLS ---
      const discountInput = document.getElementById('CartDiscountCode');
      const applyBtn = document.getElementById('ApplyDiscountBtn');
      const discountMsg = document.getElementById('DiscountMessage');
      const checkoutInput = document.getElementById('CheckoutDiscountInput');

      if (checkoutInput) checkoutInput.value = activeDiscount;

      if (discountInput && applyBtn && discountMsg) {
        if (activeDiscount) {
          discountInput.value = activeDiscount;
          discountInput.disabled = true;
          applyBtn.innerText = 'Remove';
          applyBtn.style.background = '#e74c3c';
          discountMsg.innerHTML = `<span style="color:#27ae60; font-weight:600;">Code ${activeDiscount} added! Will apply at checkout.</span>`;
        } else {
          discountInput.value = '';
          discountInput.disabled = false;
          applyBtn.innerText = 'Apply';
          applyBtn.style.background = '#2b2b36';
          discountMsg.innerHTML = '';
        }
      }

      // --- DETERMINE REQUIRED FREE GIFTS ---
      let itemsToAdd = [];
      let updates = {};
      let needsAdd = false;
      let needsUpdate = false;

      let highestTier = null;
      let sortedTiers = [...tiers].sort((a, b) => b.thresh - a.thresh);
      for (let i = 0; i < sortedTiers.length; i++) {
        if (sortedTiers[i].id && validSubtotalForGifts >= sortedTiers[i].thresh) {
          highestTier = sortedTiers[i];
          break;
        }
      }

      let validGiftIds = [];
      if (highestTier) {
        if (highestTier.id) validGiftIds.push(highestTier.id.toString());
        if (highestTier.idB) validGiftIds.push(highestTier.idB.toString());
      }

      let foundGifts = {}; 

      cart.items.forEach(item => {
        const isGift = item.properties?._free_gift || item.price === 0;
        if (isGift) {
          const vId = item.variant_id.toString();
          
          if (!validGiftIds.includes(vId) || foundGifts[vId]) {
            updates[item.key] = 0; 
            needsUpdate = true;
          } else {
            foundGifts[vId] = true;
            if (item.quantity > 1) {
              updates[item.key] = 1; 
              needsUpdate = true;
            }
          }
        }
      });

      if (highestTier) {
        validGiftIds.forEach(vId => {
          if (!foundGifts[vId]) { 
            itemsToAdd.push({ id: vId, quantity: 1, properties: { '_free_gift': 'true' } });
            needsAdd = true;
          }
        });
      }

      if (needsAdd || needsUpdate) {
        isUpdating = true; 
        
        if (needsUpdate) {
          await originalFetch(window.Shopify.routes.root + 'cart/update.js?source=drawer', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates })
          });
        }
        if (needsAdd) {
          await originalFetch(window.Shopify.routes.root + 'cart/add.js?source=drawer', {
            method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: itemsToAdd })
          });
        }
        
        await refreshCartDrawerUI();
        isUpdating = false; 
        triggerRewardsCheck();
        return; 
      }

      // --- REWARDS PROGRESS BAR UI ---
      const fill = document.getElementById('FreeGiftRewards-Fill');
      const msg = document.getElementById('FreeGiftRewards-Message');
      
      const nodes = [
        { el: document.getElementById('Ms-Ship'), thresh: shipThresh },
        { el: document.getElementById('Ms-T1'), thresh: tiers[0].thresh },
        { el: document.getElementById('Ms-T2'), thresh: tiers[1].thresh },
        { el: document.getElementById('Ms-T3'), thresh: tiers[2].thresh }
      ];

      nodes.forEach(node => {
        if (node.el) {
          const pos = (node.thresh / maxThresh) * 100;
          node.el.style.left = `${pos}%`;
          if (validSubtotalForGifts >= node.thresh) {
            node.el.classList.add('is-reached');
          } else {
            node.el.classList.remove('is-reached');
          }
        }
      });

      if (fill) fill.style.width = `${Math.min((validSubtotalForGifts / maxThresh) * 100, 100)}%`;

      let nextTier = null;
      if (validSubtotalForGifts < shipThresh) nextTier = { name: "FREE SHIPPING", diff: shipThresh - validSubtotalForGifts };
      else if (validSubtotalForGifts < tiers[0].thresh) nextTier = { name: "SOLID PERFUME", diff: tiers[0].thresh - validSubtotalForGifts };
      else if (validSubtotalForGifts < tiers[1].thresh) nextTier = { name: "SLEEP MIST", diff: tiers[1].thresh - validSubtotalForGifts };
      else if (validSubtotalForGifts < tiers[2].thresh) nextTier = { name: "FOOT SOAK + FRAGRANCE BAR", diff: tiers[2].thresh - validSubtotalForGifts };

      if (msg) {
        if (nextTier) {
          msg.innerHTML = `Add ${formatMoney(nextTier.diff)} more to unlock ${nextTier.name}!`;
        } else {
          msg.innerHTML = `🎉 You unlocked Maximum Rewards!`;
        }
      }

    } catch (err) { 
      console.error("Reward Engine Error:", err); 
      isUpdating = false;
    }
  }

  const checkoutBtns = document.querySelectorAll('button[name="checkout"], .custom-cart-drawer__checkout');
  checkoutBtns.forEach(btn => btn.onclick = null);

  triggerRewardsCheck();
});